export const RTCPeerConnection = globalThis.RTCPeerConnection
export const RTCSessionDescription = globalThis.RTCSessionDescription
export const RTCIceCandidate = globalThis.RTCIceCandidate
